import { FreePlanCard } from './FreePlanCard.tsx';
import { ProPlanCard } from './ProPlanCard.tsx';
import styles from './PlanComparison.module.css';

type Props = {
  /** Current enrolled host count (includes lighthouses and relays) */
  currentHostCount: number;
};

export function PlanComparison({ currentHostCount }: Props) {
  return (
    <section className={styles.PlanComparison}>
      <FreePlanCard currentHostCount={currentHostCount} />
      <ProPlanCard currentHostCount={currentHostCount} />
    </section>
  );
}
